import { usePage } from '@inertiajs/vue3'

export function useMediaRequests() {
  const page = usePage()

  const totalMediaRequestCount = page.props.mediaRequestCounts?.total
  const totalPendingMediaRequestCount =
    page.props.mediaRequestCounts?.pendingForPhotographer +
    page.props.mediaRequestCounts?.pendingForCompany
  const pendingMediaRequestsForPhotographerCount =
    page.props.mediaRequestCounts?.pendingForPhotographer
  const pendingMediaRequestsForCompanyCount = page.props.mediaRequestCounts?.pendingForCompany

  return {
    totalMediaRequestCount,
    totalPendingMediaRequestCount,
    pendingMediaRequestsForPhotographerCount,
    pendingMediaRequestsForCompanyCount,
  }
}
